// nastaveni pozic symbolu na valcich
import {
    forcestopnow,
    ico_he,
    reels_lenghts,
    reels_pos,
    server_result,
    behavior_config,
    server_config
} from "../framework/src/engine/madnes/madnes_variables";
import {cylinder_pos, cylinder_pos_top, icons_tmp, last_symbol, symbols} from "./adapters/madnesGameAdapter";
import {rotate_stop, stopposin, stopposin_old} from "./turbo27_core";
import {
    madnes_get_pos_y,
    madnes_set_alpha,
    madnes_set_pos_y,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {AnimFade} from "./turbo27_extanims";

export function t27_print_reels()
{
    for(var i = 0; i < reels_pos.length; i++)
    {
        print_reel(i, reels_pos[i]);
    }
}

// nastaveni pozic symbolu na valci
export var result_lock = 0;
export function set_result_lock(lock) {
    result_lock = lock;
}

function print_reel(reel, pos)
{
    if(
        reel == 0 &&
        (
            symbols[reel] >= (behavior_config.reel.spin.duration - 2) ||
            forcestopnow == 1
        ) &&
        server_result != null &&
        stopposin[0] == -1 &&
        result_lock == 0 /*&&
		madnes_get_pos_y("reels_bufer_" + (cylinder_pos.length - 1) + "_S2") < 0*/&&
        madnes_get_pos_y("reels_bufer_" + 0 + "_S1") < 0
    )
    {
        rotate_stop();
    }

    while(pos * 1 >= ( ( reels_lenghts[reel] * 1 ) + 0 ) * ico_he)
    {
        pos -= ( ( reels_lenghts[reel] * 1 ) + 0 ) * ico_he;
    }

    while(pos * 1 < 0)
    {
        pos += ( ( reels_lenghts[reel] * 1 ) + 0 ) * ico_he;
    }

    icons_tmp[2] = Math.floor(pos / ico_he);

    if(server_config.logic.reels[reel][icons_tmp[2]] == null || typeof server_config.logic.reels[reel][icons_tmp[2]] == "undefined")
    {
        icons_tmp[2] = 0;
    }

    icons_tmp[0] = icons_tmp[2]+2;
    icons_tmp[1] = icons_tmp[2]+1;
    icons_tmp[3] = icons_tmp[2]-1;
    icons_tmp[4] = icons_tmp[2]-2;

    if(!isNaN(icons_tmp[2]) && last_symbol[reel] != icons_tmp[2])
    {
        last_symbol[reel] = icons_tmp[2];
        symbols[reel]++;
    }

    var t0 = pos - (ico_he * icons_tmp[2]) + cylinder_pos_top - ico_he;

    if(isNaN(t0))
    {
        return;
    }

    for(var i = 0; i <= 4; i++)
    {
        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] >= reels_lenghts[reel]
            )
        {
            icons_tmp[i] = icons_tmp[i] * 1 - reels_lenghts[reel] * 1;
        }

        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] < 0
            )
        {
            icons_tmp[i] = reels_lenghts[reel] * 1 + icons_tmp[i] * 1;
        }
    }

    var stop_tmp = stopposin_old;
    if(stop_tmp[reel] == null || stop_tmp[reel] == -1)
    {
        stop_tmp = stopposin;
    }

    if(stop_tmp[reel] != null && stop_tmp[reel] != -1)
    {
        for(var ii = 0, l = icons_tmp.length; ii < l; ii++)
        {
            if(
                icons_tmp[ii] >= ( stop_tmp[reel] % reels_lenghts[reel] ) - 1 &&
                icons_tmp[ii] <= ( stop_tmp[reel] % reels_lenghts[reel] ) + 1
            )
            {
                icons_tmp[ii] = "S" + ( icons_tmp[ii] - ( stop_tmp[reel] % reels_lenghts[reel] ) + 1 );
            }
            else if(
                stop_tmp[reel] % reels_lenghts[reel] == 0 &&
                icons_tmp[ii] + 1 >= reels_lenghts[reel]
            )
            {
                icons_tmp[ii] = "S" + ( ( icons_tmp[ii] - ( stop_tmp[reel] % reels_lenghts[reel] ) + 1 ) % reels_lenghts[reel] );
            }
            else if(
                stop_tmp[reel] % reels_lenghts[reel] == reels_lenghts[reel] - 1 &&
                icons_tmp[ii] == 0
            )
            {
                icons_tmp[ii] = "S" + ( ( icons_tmp[ii] - ( stop_tmp[reel] % reels_lenghts[reel] ) + 1 ) % reels_lenghts[reel] + reels_lenghts[reel] );
            }
        }
    }

    for(var i = 0; i <= 4; i++)
    {
        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] >= reels_lenghts[reel]
            )
        {
            icons_tmp[i] = icons_tmp[i] * 1 - reels_lenghts[reel] * 1;
        }

        while(
            !isNaN(icons_tmp[i]) &&
            icons_tmp[i] < 0
            )
        {
            icons_tmp[i] = reels_lenghts[reel] * 1 + icons_tmp[i] * 1;
        }

    }

    for(var i = 0; i < reels_lenghts[reel]; i++)
    {
        madnes_set_pos_y("reels_bufer_" + reel + "_" + i, -9999);
        //madnes_set_pos_y("text_reels_bufer_" + reel + "_" + i, -9999);
    }

    for(var i = 0; i <= 2; i++)
    {
        madnes_set_pos_y("reels_bufer_" + reel + "_TMP" + i, -9999);
    }

    for(var i = 0; i <= 2; i++)
    {
        madnes_set_pos_y("reels_bufer_" + reel + "_S" + i, -9999);
        //madnes_set_pos_y("text_reels_bufer_" + reel + "_S" + i, -9999);
    }

    for(var i = 0; i <= 4; i++)
    {
        var posY = t0 + ( ico_he * i );

        if(reels_bg_visible) {
            madnes_set_pos_y("reels_bufer_" + reel + "_" + i + "_BG", posY);
        }

        madnes_set_pos_y("reels_bufer_"+reel+"_"+icons_tmp[i], posY);
        //madnes_set_pos_y("text_reels_bufer_"+reel+"_"+icons_tmp[i], posY);
    }
}

export function fade_in_reels_bg()
{
    return new Promise(function(resolve) {
        show_reels_bg();

        for(var i = 0; i < cylinder_pos.length; i++) {
            for(var j = 0; j < 5; j++) {

                var posY = madnes_get_pos_y("reels_bufer_"+i+"_"+icons_tmp[j]);
                var bgSpriteName = "reels_bufer_" + i + "_" + j + "_BG";

                madnes_set_pos_y(bgSpriteName, posY);
                madnes_set_visible(bgSpriteName, true);
                madnes_set_alpha(bgSpriteName, 0);

                var fadeIn = new AnimFade("in", bgSpriteName, 300);
                fadeIn.run().then(resolve);
            }
        }
    });
}

export function fade_out_reels_bg()
{
    return new Promise(function(resolve) {
        for(var i = 0; i < cylinder_pos.length; i++) {
            for(var j = 0; j < 5; j++) {

                var bgSpriteName = "reels_bufer_" + i + "_" + j + "_BG";
                var fadeOut = new AnimFade("out", bgSpriteName, 400);
                fadeOut.run().then(function() {
                    hide_reels_bg();
                    resolve();
                });
            }
        }
    });
};

var reels_bg_visible = false;
function show_reels_bg()
{
    reels_bg_visible = true;
}

function hide_reels_bg()
{
    reels_bg_visible = false;

    for(var reel = 0; reel < reels_pos.length; reel++)
    {
        for(var i = 0; i < 5; i++)
        {
            madnes_set_pos_y("reels_bufer_" + reel + "_" + i + "_BG", -9999);
        }
    }
}